<template>
    <GmapMap :options="options"
             ref="mapRef"
             :center="center"
             @zoom_changed="zoom = $event"
             :zoom="zoom"
             map-type-id="roadmap"
             style="width: 100%; height: 720px"
             @click="infoWinOpen=false">
        <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        </GmapInfoWindow>
        <GmapMarker :key="m.id + m.index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :icon="m.icon"
                    :zIndex="m.zIndex"
                    :label="m.label"
                    :clickable="true"
                    @click="toggleInfoWindow(m,index)"
                    :draggable="false" />
    </GmapMap>
</template>

<script>
	import { gmapApi } from 'vue2-google-maps';
	import { mapState, mapActions, mapMutations} from 'vuex';

	export default {
		props: ['isOfficePage'],
		data: function () {
			return {
				center: { lat: 40.677135, lng: -101.154439 },
				googleMap: null,
				zoom: 5,
				defaultIcon: { url: '/content/images/custom/map-marker.svg' },
                selectedIcon: { url: '/content/images/custom/map-marker-selected.svg' },
				options: {
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					disableDefaultUi: false,
					gestureHandling : "cooperative",
					clickableIcons: false
				},
				infoWindowPos: null,
				infoWinOpen: false,
				currentMidx: null,
				infoOptions: {
					content: '',
					//optional: offset infowindow so it visually sits nicely on top of our marker
					pixelOffset: {
						width: 0,
						height: -25
					}
				},
				markers: []
			}
		},
		computed: {
			...mapState({
				currentPage: state => state.listing.currentPage,
                selectedLocation: state => state.listing.selectedLocation,
				listing: state => state.listing.listing,
			}),
			pagedItems() {
				return this.listing;
			},
		},
		watch: {
			pagedItems: {
				handler: function (newProp, oldProp) {
					this.setMarkers(newProp);
				},
				deep: true,
				immediate: true
			},
            selectedLocation: {
                handler: function (newProp, oldProp) {
					// why are we reseting markers on agent card select
                    //this.setMarkers(this.pagedItems);
					this.makeAgentMarkersActive();
                },
                deep: true,
                immediate: true
            },
		},
		mounted: function () {
			this.$refs.mapRef.$mapPromise.then(() => {
				if (window.google !== undefined && window.google.maps !== undefined) {
					this.defaultIcon = {
						url: '/content/images/custom/map-marker.svg',
						size: new google.maps.Size(30, 41),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(20, 20),
						scaledSize: new google.maps.Size(30, 41),
						labelOrigin: {x: 15, y: 15},
					};

                    this.selectedIcon = {
                        url: '/content/images/custom/map-marker-selected.svg',
                        size: new google.maps.Size(30, 41),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(20, 20),
                        scaledSize: new google.maps.Size(30, 41),
                        labelOrigin: { x: 15, y: 15 },
                    };
				}

				this.setMarkers(this.pagedItems);
			});
		},
		methods: {
			...mapMutations('listing', { setSelectedLocation: 'setSelectedLocation' }),

			toggleInfoWindow: function (marker, idx) {
				this.infoWindowPos = marker.position;
				this.infoOptions.content = marker.infoText;
				this.setSelectedLocation(marker.id);
				marker.icon = this.selectedIcon;
				//check if its the same marker that was selected if yes toggle
				if (this.currentMidx == idx) {
					this.infoWinOpen = !this.infoWinOpen;
				}
				//if different marker set infowindow to open and reset current marker index
				else {
					this.infoWinOpen = true;
					this.currentMidx = idx;

				}
			},
			setMarkers(listing) {
				// we use marker count to let us know how many markers there are on the map and when the bound has been extended to each of these markers
				let markerCount = 0;
				this.markers = [];
				this.infoWinOpen = false;
				if (window.google !== undefined && window.google.maps !== undefined && this.$refs.mapRef !== undefined) {
					let b = new window.google.maps.LatLngBounds();
					let geocoder = new window.google.maps.Geocoder();

					let labelIndex = 1;
					if (listing.length >= 1) {
						listing.forEach((item, key) => {
							// Use temp address to get lat/lng when it is not provided
							// Some of the lat/lng from the FB data is not correct
							// we need to use address because of that

							let text = `
									<a href="${item.Url}">
										<p class='infobox-name'>Interim HealthCare of ${item.DisplayName}</p>
									</a>
									`;
									if (item.Distance != null){
										text += `<p class="infobox-distance">${item.Distance} Miles Away</p>`;
									}
							markerCount++;

							if ((item.Address.Latitude !== null && item.Address.Longitude !== null) && (item.Address.Latitude !== 0 && item.Address.Longitude !== 0)) {
								let FullAddress = `${item.Address.Address1} ${item.Address.Address2} ${item.Address.City} ${item.Address.State.Abbreviation} ${item.Address.Zipcode}`;
								text += `<p class="infobox-address">${FullAddress}</p>										
										<a class="infobox-number" href="tel:${item.Phone}">${item.Phone}</a>`;

								let marker = {
									position: {
										lat: item.Address.Latitude,
										lng: item.Address.Longitude
									},
									id: item.Guid,
									index: labelIndex,
									setMap: this.$refs.mapRef,
									title: item.DisplayName,
									label: {
										text: `${labelIndex++}`,
										color: '#FFFFFF',
										fontSize: '16px',
										fontWeight: 'bold'
									},
									infoText: text,
									icon: this.defaultIcon
								}

								// marker obj is complete, we can now add to the markers obj collection.
								// this marker gets added synchronously.
								this.markers.push(marker);

								if (listing.length > 1) {
									b.extend({
										lat: item.Address.Latitude,
										lng: item.Address.Longitude
									});
								} else if (this.markers.length === 1) {
									b.extend({
										lat: item.Address.Latitude,
										lng: item.Address.Longitude
									});

									this.center = { lat: item.Address.Latitude, lng: item.Address.Longitude };
								}
							}
						});

						// We hit this condition if all agent offices had both Lat&Lng values.
						// We can also hit this when/if the last GeoCoder async call gets executed before the main forEach loop finishes.
						if (this.isOfficePage) {
							this.$refs.mapRef.$mapPromise.then((map) => {
								if (this.markers.length === 1) {
									setTimeout(() => map.setZoom(13), 1000);
								}															
							});
							return;
						}
						if((markerCount === this.markers.length) && (this.markers.length >= 1)) {
							this.$refs.mapRef.fitBounds(b);
						}
						
					} else {
						//Add center to america when no markers available
						b.extend({
							lat: 41.909541,
							lng: -124.175651
						});

						b.extend({
							lat: 44.835672,
							lng: -67.072421
						});
						this.$refs.mapRef.$mapPromise.then((map) => {
							map.setCenter(this.center);
							map.setZoom(5);
						})
					}
				}
			},
			makeAgentMarkersActive() {
				if (window.google !== undefined && window.google.maps !== undefined && this.$refs.mapRef !== undefined) {
					let b = new window.google.maps.LatLngBounds();
					let updateMap = false;

					this.markers.forEach((marker) => {
						if (this.selectedLocation === marker.id) {
							marker.zIndex = 99;
							marker.icon = this.selectedIcon;							
							var point = new window.google.maps.LatLng(
								parseFloat(marker.position.lat),
								parseFloat(marker.position.lng)
							);
							// add each marker's location to the bounds
							b.extend(point);
							updateMap = true;
						}
						else {
							marker.zIndex = marker.index;
							marker.icon = this.defaultIcon;
						}
					});

					if (updateMap) {
						this.$refs.mapRef.panTo(b.getCenter());
					}
				}
			}
        },
    }
</script>